module.exports = __webpack_public_path__ + "static/media/email_full.4b0c8f04503efec367bc59aca67586d0.svg";